import {GetAnalysisPipelineStep, GetAnalysisFile} from 'analysis-tool/AnalysisTypes';
import {PipelineStepDataKind} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isInaccessible, assertAllAccessible} from 'graphql-client/InaccessibleInfo';

/**
 * Return output `File`s from the given `PipelineStep`, optionally filtered by the stepDataName
 */
export default function getOutputFilesFromStep(
  step: GetAnalysisPipelineStep,
  stepDataName?: string
): Array<GetAnalysisFile> {
  const files = step.outputStepDatas
    .filter(
      (stepData) =>
        stepData.kind === PipelineStepDataKind.FILE &&
        (stepDataName == null || stepData.name === stepDataName)
    )
    .flatMap((stepData) => stepData.files.filter((file) => !isInaccessible(file)));

  return assertAllAccessible(files);
}
